<template>
  <div class="app-page">
    <Header ref="header">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #page-slot>
        <BreadcrumbSelectProjectAndDataset />
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <ReviewsTab />
      </main>
    </div>
  </div>
  <TasksModal />
</template>

<script>
import Header from '@/components/Header.vue';
import ReviewsTab from '@/components/ReviewsPage/ReviewsTab.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import TasksModal from '@/components/TasksStatusComponent/TasksModalV2.vue';
import BreadcrumbSelectProjectAndDataset from '@/components/BreadcrumbSelectProjectAndDataset.vue';

export default {
  name: 'TaskBoard',
  components: {
    Header,
    ReviewsTab,
    BreadcrumbNavigation,
    TasksModal,
    BreadcrumbSelectProjectAndDataset,
  },
  inheritAttrs: false, // disables automatic attribute forwarding
  props: {
    projectId: {
      type: [String, Number],
      required: false,
    },
  }
};
</script>

